import React from 'react';
import PropTypes from 'prop-types';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
var classes = getBEMClasses('kyc-manual-directions');
var KYC_ManualDirectionsComponent = function KYC_ManualDirectionsComponent(props, context) {
  return React.createElement('div', null, React.createElement('p', {
    className: classes('description')
  }, context.t(props.section.directions)), React.createElement('a', {
    href: 'mailto:' + props.section.email,
    className: classes('email')
  }, props.section.email));
};
KYC_ManualDirectionsComponent.propTypes = {
  isOpen: PropTypes.bool,
  close: PropTypes.func,
  onConfirm: PropTypes.func
};
KYC_ManualDirectionsComponent.contextTypes = {
  t: PropTypes.func
};
export default KYC_ManualDirectionsComponent;